// extracted by mini-css-extract-plugin
export var verticalWrapPanel = "verticalWrapPanel-module--vertical-wrap-panel--Li-1o";